import { PRICED_SERVICE_TYPE } from 'components/configured-service/CreateDraftConfiguredServiceDialog/settings'
import { METERS_IN_MILE } from 'utils/distance'

/**
 * Default values for the filter form
 */
export const filterDefaultValues = {
  serviceType: 'Service',
  recurrenceType: PRICED_SERVICE_TYPE.RECURRING,
  measure: [],
  material: [],
  action: [],
  businessLine: [],
  recurrenceFrequency: '',
  recurrenceOption: null,
  method: [],
  pricingPeriod: [],
  pricingZone: [],
  radius: Math.round(2 * METERS_IN_MILE), // 2 miles in meters
  radiusCommitted: Math.round(2 * METERS_IN_MILE),
  radiusUnit: 'mi',
}
